import { module } from 'angular';

import { CANARY_CANARY_CANARYDEPLOYMENT_CANARYDEPLOYMENTEXECUTIONDETAILS_CONTROLLER } from './canaryDeploymentExecutionDetails.controller';
import { CANARY_CANARY_CANARYDEPLOYMENT_CANARYDEPLOYMENTSTAGE } from './canaryDeploymentStage';

('use strict');

export const CANARY_CANARY_CANARYDEPLOYMENT_CANARYDEPLOYMENT_MODULE = 'spinnaker.canary.canaryDeployment';
export const name = CANARY_CANARY_CANARYDEPLOYMENT_CANARYDEPLOYMENT_MODULE; // for backwards compatibility
module(CANARY_CANARY_CANARYDEPLOYMENT_CANARYDEPLOYMENT_MODULE, [
  CANARY_CANARY_CANARYDEPLOYMENT_CANARYDEPLOYMENTSTAGE,
  CANARY_CANARY_CANARYDEPLOYMENT_CANARYDEPLOYMENTEXECUTIONDETAILS_CONTROLLER,
]);
